export default __webpack_public_path__ + "static/media/eye-correct.63449126.png";